import { createFeatureSelector, createSelector, MemoizedSelector } from "@ngrx/store";
import { IRoundHistoryState, RoundHistoryState } from "./interfaces";

export const selectRoundHistory: MemoizedSelector<IRoundHistoryState, IRoundHistoryState> = createFeatureSelector(RoundHistoryState.featureKey);
export const selectRoundHistoryList: MemoizedSelector<IRoundHistoryState, number[]> = createSelector(selectRoundHistory, (roundHistory: IRoundHistoryState) => {
    return roundHistory.roundCoefficients;
});
